(function () {
  "use strict";

  angular.module("sempraWebapp").filter("availableDeviceFilter", translateFlag);

  /** @ngInject */
  function translateFlag() {
    return function (input) {
      switch (input) {
        case "1.0":
          return "AVAILABLE_TITLE";
        case "0.0":
          return "UNAVAILABLE_TITLE";
        default:
          return "AVAILABLE_TITLE";
      }
    };
  }
})();
